/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Category_DeveloperInputs */



/**
* | output |
* | --- |
* | "Developer & platform" |
*
* @param {Integrations_Category_DeveloperInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_category_developer = /** @type {((inputs?: Integrations_Category_DeveloperInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Category_DeveloperInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Entwicklung & Plattform")
	return /** @type {LocalizedString} */ ("Developer & platform")
});